module.exports = __webpack_public_path__ + "assets/a8910c6ff0bf1764d588fc36ed8c1801.png";